/* eslint-disable no-unused-vars */
import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaClipboardList } from "react-icons/fa6";
import { MdDashboard } from "react-icons/md";
import $ from "jquery";
import { FaPrayingHands } from "react-icons/fa";
import { BiSolidReport } from "react-icons/bi";

export default function AttendanaceSidebar({
  M1,
  A1,
  M2,
  A2,
  AC2,
  M3,
  A3,
  AC3,
  M4,
  A4,
  AC4,
  M5,
  A5,
  AC5,
  M6,
  A6,
  AC6,
  M7,
  A7,
  AC7,
  M8,
  A8,
  AC8,
  M9,
  A9,
  AC9,
  M10,
  A10,
  AC10,
  M11,
  A11,
  AC11, // Teacher
  M12,
  A12,
  AC12, // Commity
  M13,
  A13,
  AC13, // employee
  M14,
  A14,
  AC14, // Achivements
  M15,
  A15,
  AC15, //
  M16,
  A16,
  AC16, //
  M17,
  A17,
  AC17, //
  M18,
  A18,
  AC18, //
  M19,
  A19,
  AC19, //
  M20,
  A20,
  AC20, //
}) {
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;
  const userName = localStorage.getItem("userName");
  const refreshToken = localStorage.getItem("refreshToken");
  const token = localStorage.getItem("token");
  const location = useLocation();
  const id = localStorage.getItem("mandalDetailsId");
  // Retrieve data from localStorage

  useEffect(() => {
    // Check if the page has already been reloaded
    if (!sessionStorage.getItem("hasReloaded")) {
      sessionStorage.setItem("hasReloaded", "true");
      window.location.reload(); // Reload the window once
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    // Initialize the sidebar tree view
    $('[data-widget="treeview"]').Treeview?.();
    // eslint-disable-next-line
  }, []);

  return (
    <aside className="main-sidebar sidebar-dark-primary elevation-4">
      <Link to="/take-attendance" state={{ id: id }} className="brand-link">
        <img
          src={"dist/img/logo.jpg"}
          alt=" Logo"
          className="brand-image img-circle elevation-3"
          style={{ opacity: 0.8 }}
        />
        <span className="brand-text font-weight-light">Attendanace Worker</span>
      </Link>
      <div className="sidebar">
        <nav className="mt-2">
          <ul
            className="nav nav-pills nav-sidebar flex-column"
            data-widget="treeview"
            role="menu"
            data-accordion="false"
          >
            <li className={`nav-item has-treeview`}>
              <Link
                to="/attendance-worker-dashboard"
                state={{ id: id }}
                className={`nav-link ${A1 || ""}`}
              >
                <MdDashboard className="nav-icon mr-2" />
                <p>Dashboard</p>
              </Link>
            </li>
            <li className={`nav-item has-treeview`}>
              <Link
                to="/take-attendance"
                state={{ id: id }}
                className={`nav-link ${A8 || ""}`}
              >
                <FaClipboardList className="nav-icon mr-2" />
                <p>Take Attendance</p>
              </Link>
            </li>
            <li className={`nav-item has-treeview`}>
              <Link
                to="/register-haribhakt"
                state={{ id: id }}
                className={`nav-link ${A2 || ""}`}
              >
                <FaPrayingHands className="nav-icon mr-2" />
                <p>Register Haribhakt</p>
              </Link>
            </li>
            <li className={`nav-item has-treeview`}>
              <Link
                to="/sabha-report4"
                state={{ id: id }}
                className={`nav-link ${A3 || ""}`}
              >
                <BiSolidReport className="nav-icon mr-2" />
                <p>Sabha Report</p>
              </Link>
            </li>
            <li className={`nav-item has-treeview`}>
              <Link
                to="/parasabha-report4"
                state={{ id: id }}
                className={`nav-link ${A4 || ""}`}
              >
                <FaClipboardList className="nav-icon mr-2" />
                <p>Para Sabha Report</p>
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </aside>
  );
}
